import clsx, { type ClassValue } from 'clsx';

/** Conditional class names. Kept behind a helper so the import is uniform. */
export function cn(...values: ClassValue[]): string {
  return clsx(values);
}
